var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.value.length == 1)?[_c('span',{domProps:{"innerHTML":_vm._s(_vm.listText())}})]:(_vm.value.length > 1)?[_c('ul',{staticClass:"pl-0"},_vm._l((_vm.value),function(img,index){return _c('li',{key:index,class:[
          'd-block',
          _vm.singleValidation(index) ? 'text-dark' : 'text-danger' ],domProps:{"innerHTML":_vm._s(_vm.listText(index + 1))}})}),0)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }